import React, { useEffect } from 'react';
import {
  Container,
  FormControl,
  CircularProgress,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  TextField,
  Box,
} from '@mui/material';

import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Get_All_Managers_Action,
  Get_All_Sales_By_Managers_Email_Action,
  Get_All_TeamLeaders_and_Sales__By_Managers_Email_Action,
} from '../Redux/Actions/SalesAction';
import CheckIcon from '@mui/icons-material/Check';
import { Insert_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';
import { UpdateClientAction } from '../Redux/Actions/UsersAction';
import { Notify } from '../Utility/Notify';
import axios from 'axios';
import { db_url } from '../Api/BaseUrl';
export const ManagerAssignLeadsToSales = () => {
  const [selectedOption, setSelectedOption] = useState('Sales And Team Leader');
  const [displayList, setDisplayList] = useState([]);
  const [clearHistory, setClearHistory] = useState(false);
  const [leedData, setLeedData] = useState([]);

  const [userlogin, setUserLogin] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const dispatch = useDispatch();
  const salesAndTeamLeadersData = useSelector((state) => state.AllSales.salesforManagers);
  const Othermanagers = useSelector((state) => state.AllSales.GetAllManagers);
  // const salesAndTeamLeadersData = useSelector((state) => state.AllSales.salesforTeamLeaders);

  useEffect(() => {
    dispatch(Get_All_Sales_By_Managers_Email_Action(userlogin.data.email));
    dispatch(Get_All_Managers_Action());
    // dispatch(Get_All_TeamLeaders_and_Sales__By_Managers_Email_Action(userlogin.data.email));
  }, [dispatch, userlogin]);

  useEffect(() => {
    if (selectedOption === 'Sales And Team Leader') {
      if (Array.isArray(salesAndTeamLeadersData?.data)) {
        setDisplayList(salesAndTeamLeadersData.data);
      }
    } else {
      if (Array.isArray(Othermanagers?.data)) {
        setDisplayList(Othermanagers.data);
      }
    }
  }, [selectedOption, salesAndTeamLeadersData, Othermanagers]);

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const storedLeads = localStorage.getItem('selectedleedsbymanagers');
  const leadsall = storedLeads ? JSON.parse(storedLeads) : [];

  const [loading, setloading] = React.useState(true);
  const [selectedValue, setSelectedValue] = useState(null);
  const [sendloading, setsendloading] = React.useState(false);

  //add state to sales
  const handleAutocompleteChange = (event, newValue) => {
    setSelectedValue(newValue);
    // console.log("القيمة المختارة:", newValue);

    // يمكنك هنا إجراء أي عمليات أخرى تحتاجها مع القيمة المختارة
  };

  //     useEffect(()=>{
  //         // console.log(selectedValue?.name);          // اسم الـ sales
  // // console.log(selectedValue?.userlog?._id);  // ID الخاص بحساب الـ user
  // // console.log(selectedValue?.userlog?.fcmToken); // الـ FCM Token اللي هتستخدمه في الإشعارات
  //     },[selectedValue])

  const conirmassign = async (e) => {
    e?.preventDefault();

    if (selectedValue === '') {
      Notify('error', 'Please select sales', 'error');
      return;
    } else {
      setloading(true);
      setsendloading(true);

      const updatePromises = leadsall.map((leadId) =>
        dispatch(
          UpdateClientAction(leadId, {
            sales: selectedValue,
            assign: true,
            // lastdateassign:new Date().toISOString().split('T')[0], // التاريخ الحالي
            lastdateassign: new Date().toLocaleString(),
          }),
        ),
      );

      //           const response =  axios.post("http://localhost:8000/api/v1/Notification/send-fcm", {
      //   // fcmToken: "dxQwqbs7Z3FrdeBOb1Epb_:APA91bE_3tXhTuYhMBOb1c1LMbPK9hk1Omb0tGLGko8W54sKcazmaFs28ZBVRfGbOlq73jBPsCCGCIlL7pehxcg45hrdV5zikPQHo90qvw1s8S-2MJnHGQ8",
      //       fcmToken: selectedValue?.userlog?.fcmToken,
      //   title: "💬 New Assign Lead (FCM)",
      // body: `    New Assign Lead From User : ${userlogin?.data?.name}  And Assigned To User Name : ${selectedValue?.name}`,
      // }, {
      //   headers: {
      //     "Content-Type": "application/json"
      //   }
      // });
      // console.log("✅ Notification response:", response.data);

      const notificationPromises = leadsall.map((leadId, index) => {
        const leadName = leedData.find((lead) => lead._id === leadId)?.name || 'Lead';

        // return axios.post("https://apirender8.onrender.com/api/v1/Notification/send-fcm", {
        return axios
          .post(
            `${db_url}api/v1/Notification/send-fcm`,
            {
              fcmToken: selectedValue?.userlog?.fcmToken,
              title: '💬 New Assign Lead (FCM)',
              body: `New Assign Lead From User: ${userlogin?.data?.name} | Assigned Lead ${leadName} (${index + 1}) For You`,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            },
          )
          .then((response) => {
            // console.log(`✅ Notification ${index + 1} response:`, response.data);
          })
          .catch((error) => {
            console.error(`❌ Failed to send notification ${index + 1}:`, error);
          });
      });

      await Promise.all(notificationPromises);
      await Promise.all(updatePromises);

      // بعد تحديث الـ Leads بنجاح

      //تسجيل كل هذه الداتا
      // LeadAssigned
      // تسجيل كل Lead بشكل منفصل في الجدول الخاص بها
      const insertPromises = leadsall.map((leadId) =>
        dispatch(
          Insert_Lead_Assigned_Data_Action({
            LeadId: leadId, // تسجيل الـ LeadId الفردي
            date_Assigned: new Date().toISOString().split('T')[0], // التاريخ الحالي
            Assigned_From: userlogin.data._id, // المستخدم الذي قام بالإسناد
            Assigned_to: selectedValue, // اسم الـ sales
            clearHistory: clearHistory, // ✅ أضف هذا السطر
          }),
        ).catch((error) => {
          Notify('error', `Failed to insert lead ${leadId}`, 'error');
          throw error; // لإيقاف العملية إذا أردت
        }),
      );
      // انتظار انتهاء جميع عمليات الإدخال
      await Promise.all(insertPromises);

      setloading(false);
      setsendloading(false);
    }
  };

  const resleeddata = useSelector((state) => state.Allusers.Get_users);

  useEffect(() => {
    if (loading === false) {
      if (resleeddata && resleeddata.status === 200) {
        Notify('success', 'Successfully updated', 'success');
        setTimeout(() => {
          window.location.href = '#/LeadsForManagers';
        }, 1500);
      } else {
        Notify('error', 'Failed to update', 'error');
      }
    }
  }, [loading]);

  return (
    <Container className="startpage">
      <h1 style={{ color: '#102dff' }}>
        Choose To Assign Leads to Sales Or Team Leader Or Other Manager
      </h1>

      <FormControl>
        <FormLabel id="radio-buttons-group-label">Choose</FormLabel>
        <RadioGroup
          row
          aria-labelledby="radio-buttons-group-label"
          value={selectedOption}
          onChange={handleRadioChange}
          name="radio-buttons-group"
        >
          <FormControlLabel
            value="Sales And Team Leader"
            control={<Radio />}
            label="Sales And Team Leader"
          />
          <FormControlLabel value="other Manager" control={<Radio />} label="Other Manager" />
        </RadioGroup>
      </FormControl>

      <Autocomplete
        options={displayList.filter((option) => option?.userlog?.name !== userlogin?.data?.name)}
        onChange={handleAutocompleteChange}
        value={selectedValue}
        getOptionLabel={(option) => {
          if (selectedOption === 'Sales And Team Leader') {
            return option.name || 'Unknown';
          } else {
            return option.name || option.email || 'Unknown';
          }
        }}
        renderOption={(props, option) => (
          <li
            {...props}
            style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
          >
            <div>
              <span>{option.name || option.email}</span>
              <br />
              <span style={{ fontSize: '0.8rem', color: '#666' }}>
                {option.userlog?.role || option.role || 'No role specified'}
              </span>
            </div>
            {selectedOption === 'Sales And Team Leader' && (
              <span style={{ color: 'royalblue', fontWeight: 'bold' }}>
                {option.userlog?.role || ''}
              </span>
            )}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={
              selectedOption === 'Sales And Team Leader'
                ? 'Select Sales/Team Leader'
                : 'Select Manager'
            }
            variant="outlined"
          />
        )}
        style={{ marginTop: 20, width: '100%' }}
      />

      <Box display="flex" alignItems="center" mt={2} sx={{ gap: '10px' }}>
        <label
          htmlFor="clear-history"
          style={{
            position: 'relative',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <input
            type="checkbox"
            id="clear-history"
            checked={clearHistory}
            onChange={(e) => setClearHistory(e.target.checked)}
            style={{
              position: 'absolute',
              opacity: 0,
              height: 0,
              width: 0,
            }}
          />
          <span
            style={{
              display: 'inline-block',
              width: '20px',
              height: '20px',
              border: '2px solid #2196F3',
              borderRadius: '4px',
              transition: 'all 0.3s',
              position: 'relative',
              background: clearHistory ? '#2196F3' : 'transparent',
            }}
          >
            {clearHistory && (
              <span
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '12px',
                  height: '12px',
                  background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E")`,
                }}
              />
            )}
          </span>

          {/* تأثيرات hover */}
          <style>{`
                             label:hover span:first-of-type {
                               border-color: #1565C0;
                               transform: scale(1.05);
                               box-shadow: 0 0 8px rgba(33, 150, 243, 0.3);
                             }
                           `}</style>
        </label>

        <label
          htmlFor="clear-history"
          style={{
            cursor: 'pointer',
            userSelect: 'none',
            fontSize: '16px',
            color: '#333',
            transition: 'color 0.3s',
          }}
        >
          Clear previous comments for this sales
        </label>
      </Box>

      {/* <button className='button-light ' style={{marginTop:'60px'}} onClick={conirmassign}>Confirm Assign <CheckIcon/></button> */}

      <div className="d-flex justify-content-center w-100 my-3">
        <div
          onClick={!sendloading ? conirmassign : null}
          className="mx-2 button-18"
          style={{
            width: '50%',
            position: 'relative',
            pointerEvents: sendloading ? 'none' : 'auto',
            opacity: sendloading ? 0.6 : 1,
            cursor: sendloading ? 'not-allowed' : 'pointer',
            background: '#102dff',
          }}
        >
          {sendloading === true ? (
            <CircularProgress size={24} style={{ color: 'white' }} />
          ) : (
            <>
              <CheckIcon /> Send
            </>
          )}
        </div>
      </div>
    </Container>
  );
};
